export default __webpack_public_path__ + "static/media/details.4001e26a.png";